// extracted by mini-css-extract-plugin
export default {"section":"Search_section__2p9Sn","search":"Search_search__Wncrn","seachIcon":"Search_seachIcon__Ai+nE","searchIcon":"Search_searchIcon__a+82O"};